<template>
  <div class="header">
    <div class="container">
      <img class="logo" src="@/assets/img/logo_word_zh.7d8620d0.png" alt="Logo" @click="goHome">
      <div class="nav">
        <li @click="goPromotion">推广赚现金</li>
        <li @click="login">{{ loggedIn ? '我的账号' : '登录' }}</li>
      </div>
    </div>
  </div>
</template>

<script>
import { openLogin } from '@/utils/login'
import { withInviteQuery } from '@/utils/channel'
import { session } from '@/utils/auth'

export default {
  computed: {
    loggedIn() {
      return !!session.token
    },
  },
  methods: {
    goHome() {
      if (this.$route.path !== '/' && this.$route.path !== '/invite') {
        this.$router.push({ path: '/', query: withInviteQuery(this.$route.query) }).catch(() => {})
      } else {
        window.scrollTo(0, 0)
      }
    },
    goPromotion() {
      if (this.$route.path !== '/promotion') {
        this.$router.push({ path: '/promotion', query: withInviteQuery(this.$route.query) }).catch(() => {})
        this.$nextTick(() => {
          window.scrollTo(0, 0)
        })
      }
    },
    login() {
      openLogin()
    },
  },
}
</script>

<style scoped>
@import url(../assets/css/header.css);
</style>
